<template>
    <div class="c-error-page--503" data-css="c-error-page">
			<div class="grid__container">
				<div class="grid__row">
			                 <div class="error-page__content">
			              <h2 class="error-page__headline">Die Seite ist aktuell nicht verfügbar. (Fehler Code {{ fetchError.errorCode }})</h2>
			                <div class="error-page__description">                                
                                <p>{{ fetchError.errorMessage }}</p>
                            </div>			                
			            </div>
			            <div class="error-page__watermark" aria-hidden="true"><div class="error-page__watermark_bg" aria-hidden="true">&nbsp;</div></div>
			
			</div>
        </div>
    </div>	

</template>

<script>


export default {
    name: 'newsroom-ch-fetch-error',
    props: [
        'fetchError'
    ]

}

</script>